import type { ReactNode } from 'react';

import type { Role } from '@/constants/roles';
import { useAppSelector } from '@/store/hooks';
import { selectUserRoles } from '@/store/userSlice';
import { ForbiddenPage } from '@/pages/ForbiddenPage';

interface ProtectedRouteProps {
  roles?: readonly Role[];
  children: ReactNode;
}

// ProtectedRoute is mounted *inside* the AuthGate, so it can assume the
// user is already authenticated. Its only job is the role gate.
//
// - omitted `roles` prop = any authenticated user
// - non-empty `roles` = user must have at least one of the listed roles
export const ProtectedRoute = ({ roles, children }: ProtectedRouteProps): React.JSX.Element => {
  const userRoles = useAppSelector(selectUserRoles);

  if (roles && roles.length > 0) {
    const allowed = roles.some((r) => userRoles.includes(r));
    if (!allowed) return <ForbiddenPage />;
  }

  return <>{children}</>;
};
